import React, {useEffect, useRef, useState} from 'react';
import {useDispatch, useSelector} from "react-redux";
import {invoicesAction} from "../../redux/toolkit/invoicesSlice";
import DashboardContainer from "../sideBar/DashboardContainer";
import BootstrapTable from "react-bootstrap-table-next";
import {columnsTable} from "./columnsTable";
import DataPicker from "./DataPicker";
import moment from "moment";
import paginationFactory, {
    PaginationListStandalone,
    PaginationProvider,
    SizePerPageDropdownStandalone
} from "react-bootstrap-table2-paginator";
import Message from "../../helper/messages/Message";
import Loading from "../../helper/Loading";
import PageLayout, {Card, CardHeader} from "../layout/PageLayout";
import c from './invoice.module.css';

const PLANS = [
    {
        title: 'Monthly per Endpoint',
        description: 'Unlimited compounds on the endpoints you subscribe to, billed monthly.',
        subject: 'Monthly Endpoint Volume Discount Inquiry',
    },
    {
        title: 'Pay per Compound',
        description: 'Buy a number of compounds and screen them against every active endpoint.',
        subject: 'Pay-Per-Compound Pricing Inquiry',
    },
];

const InvoiceContainer = () => {

    const dispatch = useDispatch();
    const result = useSelector(state => state?.invoicesReducer);

    const {data, status_code, status, message} = result?.data;
    const {loading} = result;

    const [fromDateState, setFromDateState] = useState(null);
    const [toDateState, setToDateState] = useState(null);

    const toRef = useRef();
    const fromRef = useRef();


    useEffect(() => {
        if (fromDateState && toDateState) {
            const fromDate = moment(fromDateState, 'ddd MMM DD YYYY HH:mm:ss [GMT]ZZ (zz)').format('YYYY-MM-DD HH:mm:ss');
            const toDate = new Date(toDateState).toISOString().slice(0, 19).replace('T', ' ');

            if (
                (fromRef.current?.toString() !== fromDateState.toString()
                    || toRef.current?.toString() !== toDateState.toString())
                && !fromDate.includes('GMT+') && !toDate.includes('GMT+')
            ) {
                if (!loading) {
                    dispatch(invoicesAction({
                        "issue_start_date": fromDate,
                        "issue_end_date": toDate,
                    }))
                }
                toRef.current = toDateState;
                fromRef.current = fromDateState;
            }
        }
    }, [dispatch, fromDateState, loading, toDateState]);

    const options = {
        custom: true,
        totalSize: data?.length
    };

    return (
        <DashboardContainer>
            {/* Titled to match the sidebar entry - the backend's "open the
                Payments page" messages have to name something findable. */}
            <PageLayout title='Payments'
                        subtitle='Choose a pricing model to get in touch with sales, or review your issued invoices.'>

                {/* These were <button> elements that did nothing, wrapping a mailto
                    link. They are links now, so the whole card is the click target. */}
                <div className={c.planGrid}>
                    {PLANS.map(plan => (
                        <a key={plan.title} className={c.planCard}
                           href={`mailto:sales@toxometris.ai?subject=${encodeURIComponent(plan.subject)}`}>
                            <span className={c.planTitle}>{plan.title}</span>
                            <span className={c.planDescription}>{plan.description}</span>
                            <span className={c.planCta}>Contact sales@toxometris.ai</span>
                        </a>
                    ))}
                </div>

                <div className={c.filterBar}>
                    <DataPicker setFromDateState={setFromDateState} setToDateState={setToDateState}
                                toDateState={toDateState} fromDateState={fromDateState}/>
                </div>

                {(!loading && status === 'success' && data?.length > 0) &&
                    <Card padded={false}>
                        <CardHeader title='Issued invoices'/>
                        <div className={c.invoicesContainers}>
                            <PaginationProvider pagination={paginationFactory(options)}>
                                {({paginationProps, paginationTableProps}) => {
                                    return <div>
                                        <div className={`${c.invoicesContent} invoicesContent`}>
                                            <BootstrapTable
                                                keyField="id"
                                                data={data}
                                                columns={columnsTable()}
                                                {...paginationTableProps}
                                            />
                                        </div>
                                        <div className={c.sizePagination}>
                                            <SizePerPageDropdownStandalone {...paginationProps}/>
                                            <PaginationListStandalone {...paginationProps}/>
                                        </div>
                                    </div>
                                }}
                            </PaginationProvider>
                        </div>
                    </Card>
                }
                {
                    !loading && status !== 'error' && !data?.length && <Message message={message}/>
                }
                {
                    status === 'error' && status_code !== 200 && !loading &&
                    <Message message={message} status={status} status_code={status_code}/>
                }
                {
                    loading && <Loading/>
                }
            </PageLayout>

        </DashboardContainer>

    );
};

export default InvoiceContainer;
